import axiosInstance from "./axios-config";
import { AxiosError } from "axios";
import { saveToken, removeToken } from "../utils/auth-storage";

interface LoginCredentials {
  email: string;
  password: string;
}

interface LoginResponse {
  accessToken: string;
  user?: {
    id: number;
    email: string;
    role: string;
  };
}

/**
 * Effectue une requête d'authentification
 */
export const postLogin = async (
  data: LoginCredentials
): Promise<LoginResponse> => {

  try {
    const response = await axiosInstance.post("/auth/login", data);

    if (response.data && response.data.accessToken) {

      // Utiliser notre système amélioré pour sauvegarder le token
      saveToken(response.data.accessToken);

      return response.data;
    } else {
      console.error("❌ API: Login response missing accessToken:", response.data);
      throw new Error("Invalid authentication response");
    }
  } catch (error) {
    console.error("💥 API: Login request failed:", error);
    throw error;
  }
};

/**
 * Récupère les informations de l'utilisateur connecté
 */
export const getMe = async () => {
  try {
    const response = await axiosInstance.get("/auth/me");
    return response.data;
  } catch (error) {
    console.error("💥 API: Failed to get user profile:", error);

    // Correction: Vérifier que error est de type AxiosError et a une propriété response
    if (error && typeof error === "object" && "response" in error) {
      const axiosError = error as AxiosError;
      if (axiosError.response?.status === 401) {
        removeToken();
      }
    }

    throw error;
  }
};

/**
 * Déconnecte l'utilisateur
 */
export const logout = () => {
  removeToken();
};
